import { createFileRoute } from '@tanstack/react-router'
import ConceptNotes from 'Concept/components/Concept/Sections/ConceptNotes'

export const Route = createFileRoute('/concept/$conceptId/notes')({
    component: ConceptNotes,
})
